module.exports = __webpack_public_path__ + "assets/img/dl.819bda70.png";